import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M13.1 11.4a.78.78 0 0 1-.54-.23L8 6.44l-4.56 4.73a.75.75 0 1 1-1.08-1.05l5.1-5.29A.77.77 0 0 1 8 4.61a.77.77 0 0 1 .54.22l5.1 5.29a.76.76 0 0 1 0 1.07.73.73 0 0 1-.54.21Z';
const draw24px =
  'M17.23,16.17a.72.72,0,0,1-.54-.23L12,11.08,7.31,15.94a.75.75,0,1,1-1.08-1l5.23-5.42a.78.78,0,0,1,1.08,0l5.23,5.42a.75.75,0,0,1-.54,1.27Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ChevronUpIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'chevronUp'),
) as IconWithRender;

ChevronUpIcon.displayName = 'ChevronUpIcon';
ChevronUpIcon.propTypes = Icon.propTypes;
ChevronUpIcon.renderIcon = (props) => <ChevronUpIcon {...props} />;
export default ChevronUpIcon;
